module.exports = __webpack_public_path__ + "static/img/xi_15.ae3f2cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_15.jpg
// module id = Uomv
// module chunks = 1